module.exports = __webpack_public_path__ + "img/1626682929.2b53002e.jpg";